// extracted by mini-css-extract-plugin
export default {"interlayerPageWrapper":"css_interlayerPageWrapper__3PYBO"};